import { useViewport } from "src/contexts";
import { Css } from "~generated/css";
import { GoogleAuthButton } from "./GoogleAuthButton";

type GoogleAuthSectionProps = {
  mode: "signIn" | "signUp";
  onClick: () => void;
};

export function GoogleAuthSection({ mode, onClick }: GoogleAuthSectionProps) {
  const { isMobile } = useViewport();
  return (
    <>
      <div css={Css.tac.t12.gray900.py1.$}>or</div>
      {isMobile ? (
        <div css={Css.wPx(200).$}>
          <GoogleAuthButton mode={mode} onClick={onClick} />
        </div>
      ) : (
        <GoogleAuthButton mode={mode} onClick={onClick} />
      )}
    </>
  );
}
